import { VerdantMark } from './VerdantMark';
import styles from './Nav.module.css';

export const LogoFull = () => {
  return (
    <div className={styles.fullLogo}>
      <VerdantMark size={34} />
      <div>
        <div className={styles.wordmark}>TIGO</div>
        <div className={styles.descriptor}>Developer portal</div>
      </div>
    </div>
  );
};
